<template>
	<div class="home meets">
		<div class="top">
			<tabs @tabChange="initContent" :list="list">
				<div slot="current">
					<!-- <div class="">
            <div class="selects" @click="showPicker = true">
              <h3 class="">
                {{ texts }}
              </h3>
              <van-icon class="icons" name="arrow-down" color="#489FFF" />
            </div>
          </div> -->
					<van-popup v-model="showPicker" round position="bottom">
						<van-picker show-toolbar :columns="columns" value-key="roomName" @cancel="showPicker = false"
							@confirm="onConfirm" />
					</van-popup>
					<div style="display:flex;width:100%; justify-content: center;margin-top:10px;margin-bottom:10px">
						<div class="demo" style="margin-right:10px">
							<span>已预约</span>
							<van-icon name="success" color="#489fff" />
						</div>
						<div class="demo">
							<span>审核中</span>
							<van-icon name="success" color="#009700" />
						</div>

					</div>
					<van-pull-refresh v-model="isLoading1" @refresh="onRefresh1">
						<van-list>
							<van-cell>
								<div class="borders">
									<div class="top">
										<div class="left arrows" @click="preWeek">
											<img src="../../assets/meeting/left.png" alt="" />
										</div>
										<div class="centers">
											<p>{{ currentDates }}</p>
										</div>
										<div class="right arrows" @click="nextWeek">
											<img src="../../assets/meeting/right.png" alt="" />
										</div>
									</div>
									<div class="daterange">
										<ul class="lists">
											<li>
												<span>日期</span>

												<span>时段</span>
											</li>
											<li class="week" v-for="(item, index) in infos.tiltles" :key="index">
												<span>{{ item.weekName }}</span>
												<span>{{ item.dateName }}</span>
											</li>
										</ul>
									</div>
									<div>
										<div class="level_room" v-for="(item, index) in infos.conferenceWeeks"
											:key="index">
											<h4>{{ item.conferenceName }}</h4>
											<div class="autoFlex">
												<div class="labels">
													<p>上午</p>
													<p>下午</p>
													<p>晚上</p>
												</div>
												<div class="roomList">
													<span class="room" v-for="(iitem,idxs) in item.cellinfoList"
														:key="iitem.auditId"
														@click="auditRoom(iitem,item.conferenceName,idxs)"
														:class="{'disableds':iitem.enable==0}">
														<van-icon name="success" color="#009700"
															v-if="iitem.status == 1" />
														<van-icon name="success" color="#489fff"
															v-if="iitem.status == 2" />
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</van-cell>
						</van-list>
					</van-pull-refresh>
				</div>
				<div slot="history">
					<div class="currentPre" @click="show = true">
						<div style="width: 80%; text-align: center">
							<div v-if="!isShow" class="place">
								<span>开始时间</span>
								<span>-</span>
								<span>结束时间</span>
							</div>
							<div v-else class="fontss">{{ date }}</div>
						</div>

						<van-icon name="calendar-o" />
					</div>
					<van-calendar allow-same-day v-model="show" type="range" :min-date="minDate" :max-date="maxDate"
						@confirm="calendarConfirm" />
					<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
						<div class="autoFixed">
							<van-list>
								<van-cell v-for="(item, index) in histroyLists" :key="index"
									style="margin-bottom: 10px; padding: 0; border-radius: 5px">
									<div class="main">
										<span class="roomName">{{ item.roomName }}</span>
										<div class="history-left" style="margin-top: 20px">
											<div class="history-item">
												<span>会议时段：</span>
												<span>{{ item.useDate }}</span>
												<span style="margin-left: 10px">{{ maps[item.timeStatus]}}</span>
											</div>
											<div class="history-item">
												<span>会议开始时间：</span>
												<span>{{ item.startMeettime }}</span>
											</div>
											<div class="history-item">
												<span>会议结束时间：</span>
												<span>{{ item.endMeettime }}</span>
											</div>
											<div class="history-item">
												<span>会议用途：</span>
												<span>{{ item.purpose }}</span>
											</div>
											<div class="history-item">
												<span>联系人：</span>
												<span>{{ item.personName }}</span>
											</div>
											<div class="history-item">
												<span>联系电话：</span>
												<span>{{ item.personPhone }}</span>
											</div>
											<div class="history-item">
												<span>预约时间：</span>
												<span>{{ item.createTime }}</span>
											</div>
										</div>
										<!-- 审核中 -->
										<div class="hisotry-right" >
											<img v-if="item.apptStatus == 1" src="../../assets//meeting/shenhezhong.png"
												alt="" />
											<!-- 同意 -->
											<img v-if="item.apptStatus == 2" src="../../assets/meeting/done.png"
												alt="" />
											<!-- 驳回 -->
											<img v-if="item.apptStatus == 3" src="../../assets//meeting//bohui.png"
												alt="" />
											<!-- 已取消 -->
											<img v-if="item.apptStatus == 9" src="../../assets/meeting//quxiao.png"
												alt="" />
										</div>

										<van-button plain type="info" size="small" class="userBtn"
											@click="cancleRooms(item)" v-if="item.apptStatus == 1">取消
										</van-button>

										<!-- <div class="userBtn">取消</div> -->
										<!-- <div class="userBtn">退房</div> -->
									</div>
								</van-cell>
								<!-- 加载的内容-->
							</van-list>
						</div>
					</van-pull-refresh>
				</div>
			</tabs>
		</div>
		<van-popup v-model="showModal" overlay-class='modals'  closeable close-icon="close">
			<div style="position: relative;">
				<div class="history-left tts" style="">
					<div class="history-item">
						<span>会议时段：</span>
						<span>{{ showMsg.useDate }}</span>
						<span style="margin-left: 10px">{{
				  maps[showMsg.timeStatus]
				}}</span>
					</div>
					<div class="history-item">
						<span>会议开始时间：</span>
						<span>{{ showMsg.startMeettime }}</span>
					</div>
					<div class="history-item">
						<span>会议结束时间：</span>
						<span>{{ showMsg.endMeettime }}</span>
					</div>
					<div class="history-item">
						<span>会议用途：</span>
						<span>{{ showMsg.purpose }}</span>
					</div>
					<div class="history-item">
						<span>联系人：</span>
						<span>{{ showMsg.personName }}</span>
					</div>
					<div class="history-item">
						<span>联系电话：</span>
						<span>{{ showMsg.personPhone }}</span>
					</div>
					<div class="history-item">
						<span>预约时间：</span>
						<span>{{ showMsg.createTime }}</span>
					</div>
					
				</div>
				<div class="hisotry-right" style="position: absolute;top: 50%;transform: translateY(-50%);right: 20px;">
					<img v-if="showMsg.apptStatus == 1" src="../../assets//meeting/shenhezhong.png"
						alt="" />
					<!-- 同意 -->
					<img v-if="showMsg.apptStatus == 2" src="../../assets/meeting/done.png"
						alt="" />
					<!-- 驳回 -->
					<img v-if="showMsg.apptStatus == 3" src="../../assets//meeting//bohui.png"
						alt="" />
					<!-- 已取消 -->
					<img v-if="showMsg.apptStatus == 9" src="../../assets/meeting//quxiao.png"
						alt="" />
				</div>
			</div>
	</van-popup>
	</div>
</template>

<script>
	import tabs from "../../components/tabs.vue";
	import {
		getMeetingList,
		getCurrentWeekMeeting,
		addAudit,
		getAuditHistoryList,
		cancleMeeting,
		queryMeetingInfos
	} from "../../apis/api";
	import {
		Toast,
		Dialog
	} from "vant";
	import {
		formatTime,
		getCurrentDate
	} from "../../utils/index";
	export default {
		data() {
			return {
				messages: "",
				isShowtuifang: false,
				show: false,
				showMsg:{},
				fileList: [],
				date: "",
				value: "",
				maps: ["上午", "下午", "晚上"],
				texts: "请选择会议楼",
				minDate: new Date(2000, 0, 1),
				maxDate: new Date(2100, 0, 31),
				list: [{
						name: "当前预约",
						type: "current",
					},
					{
						name: "历史预约",
						type: "history",
					},
				],
				isLoading1: false,
				isLoading: false,
				loading: false,
				isShow: false,
				roomLists: [],
				level1: "",
				showConfirm: false,
				columns: [1, 2, 3],
				showPicker: false,
				infos: [],
				histroyLists: [],
				beginTime: "",
				endTime: "",
				date: "",
				pageSize: 10,
				pageNo: 1,
				currentDates: "",
				currentWeeks: 0,
				showModal: false
			};
		},
		beforeDestroy() {
			clearInterval(this.setTimer);
			this.setTimer = null;
		},
		mounted() {
			document.title = "会议预约";
			// this.getRoomsLists();
			let _this = this;
			this.initContent();
			this.getAuditRoomList(0);
			this.currentDates = getCurrentDate();
		},

		methods: {
			cancleRooms(item) {
				console.log(item);
				cancleMeeting({
					appointmentId: item.id,
				}).then((res) => {
					Toast("取消完成");
					this.beginTime = this.beforeDay(1);

					this.endTime = formatTime();
					this.pageSize = 10;
					this.pageNo = 1;
					// this.getHistoryLists();
					getAuditHistoryList({
						entryTime: this.beginTime,
						leaveTime: this.endTime,
						pageNo: this.pageNo,
						pageSize: this.pageSize,
					}).then((res) => {
						this.histroyLists = res.result.records;
						console.log(res, "=================");
					});
				});
			},
			nextWeek() {
				console.log(this.currentWeeks)
				if(this.currentWeeks==1)
				{
					Toast("已是最近未来一周");
				}
				else
				{
					this.currentWeeks+=1
				}
				this.getAuditRoomList(this.currentWeeks);
			},
			preWeek() {
				console.log(this.currentWeeks)
				this.currentWeeks-=1
				this.getAuditRoomList(this.currentWeeks);
			},
			getAuditRoomList(index) {
				getCurrentWeekMeeting({
					token: localStorage.getItem("token") || "",
					deltaWeek: index,
				}).then((res) => {
					console.log("===", res);
					if (res.code == 500) {
						Toast(res.message);
						return;
					} else {
						this.isLoading1 = false;
						this.infos = res.result;
						//this.currentWeeks = index
						localStorage.setItem('weeks', JSON.stringify(this.infos.tiltles))
					}
				});
			},
			auditRoom(item, name, index) {
			
				if(item.enable==0){
					if(item.status!=0){
						this.showModal = true;
						this.showMsg = {}
						queryMeetingInfos({auditId:item.auditId}).then(res=>{
							
							this.showMsg = {...res.result}
						})
					}else{
						Toast('当前会议室不可预约')
					}
					
				}else{
					if(item.status==0){
						this.$router.push({
							path: "/meetingDetail",
							query: {
								id: item.auditId,
								name: name,
								index: index
							},
						});
					}else{
						this.showModal = true;
						this.showMsg = {}
						queryMeetingInfos({auditId:item.auditId}).then(res=>{
							this.showMsg = {...res.result}
						})
					}
				}
				
			},

			beforeDay(num) {
				//设置日期，当前日期的前num天
				var myDate = new Date(); //获取今天日期
				// myDate.setDate(myDate.getDate() - (num - 1));
				var dateArray = [];

				var dateTemp;

				let str = myDate.getMonth() + 1;
				let dd = myDate.getFullYear() - 1;

				// debugger;
				dateTemp = str > 10 ? str : "0" + str + "-" + myDate.getDate();
				// dateArray.push(dateTemp);
				// myDate.setDate(myDate.getDate() + flag);
				return dd + "-" + dateTemp;
			},
			initContent(value) {
				if (value == 0) {
					getMeetingList().then((res) => {
						console.log(res);
						this.columns = res.result;
					});
					this.getAuditRoomList(this.currentWeeks);
				} else {
					this.beginTime = this.beforeDay(1);

					this.endTime = formatTime();
					this.pageSize = 10;
					this.pageNo = 1;
					// this.getHistoryLists();
					getAuditHistoryList({
						entryTime: this.beginTime,
						leaveTime: this.endTime,
						pageNo: this.pageNo,
						pageSize: this.pageSize,
					}).then((res) => {
						this.histroyLists = res.result.records;
						console.log(res, "=================");
					});
				}
			},
			onConfirm(e) {
				console.log(e);
				this.showPicker = false;
				this.texts = e.roomName;
			},
			formatDate(date) {
				return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			},
			calendarConfirm(e) {
				console.log(e);
				this.show = false;
				const [start, end] = e;
				this.show = false;
				this.isShow = true;
				this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
				this.beginTime = this.formatDate(start);
				this.endTime = this.formatDate(end);
			},
			onCancel() {},
			onChange() {},
			onRefresh1() {
				this.getAuditRoomList(this.currentWeeks);
			},
			onRefresh() {
				this.beginTime = this.beforeDay(1);

				this.endTime = formatTime();
				this.pageSize = 10;
				this.pageNo = 1;
				// this.getHistoryLists();
				getAuditHistoryList({
					entryTime: this.beginTime,
					leaveTime: this.endTime,
					pageNo: this.pageNo,
					pageSize: this.pageSize,
				}).then((res) => {
					this.isLoading = false;
					this.histroyLists = res.result.records;
					console.log(res, "=================");
				});
			},
		},
		components: {
			tabs,
		},
	};
</script>

<style lang="less" scoped>
	.labels {
		width: 80px;

		//   border-right: 1px solid #eee;
		p {
			width: 100%;
			text-align: center;
			height: 80px;
			line-height: 80px;
			border-bottom: 1px solid #eee;
		}

		p:last-child {
			//   border-bottom: none;
		}
	}

	.autoFlex {
		display: flex;
	}

	.roomList {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		border-left: 1px solid #eee;
		flex: 1;

		.room {
			width: 13.9%;
			border-right: 1px solid #eee;
			height: 80px;
			border-bottom: 1px solid #eee;
			text-align: center;
			line-height: 80px;
		}

		.room:nth-child(7n) {
			border-right: none;
		}
	}

	.level_room {
		h4 {
			width: 100%;
			text-align: center;
			color: #489fff;
			border-top: 1px solid #489fff;
			border-bottom: 1px solid #489fff;
			margin: 0;
			height: 80px;
			line-height: 80px;
			font-size: 40px;
			// margin-top: 20px;
		}
	}

	.lists {
		display: flex;

		li {
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			border-right: 1px solid #eee;
		}

		.lasts {
			border: none;
		}
	}

	.borders {
		border: 1px solid #eee;
		margin: 0 auto;
		margin-left: 30px;
		// padding-top: 10px;
	}

	.top {
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid #eee;

		// padding: 10px 20px;
		.left {
			border-right: 1px solid #eee;
			padding: 20px 10px;
			padding-bottom: 0;
			width: 9.5%;
		}

		.right {
			border-left: 1px solid #eee;
			padding: 20px 10px;
			padding-bottom: 0;
			width: 9.5%;
		}

		.arrows {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 60px;

			img {
				width: 40px;
				height: 40px;
			}
		}
	}

	.currentPre {
		width: 80%;
		text-align: center;
		display: flex;
		justify-content: center;
		margin: 0 auto;
	}

	.selects {
		width: 50%;
		margin: 0 auto;
		border: 2px solid #489fff;
		border-radius: 80px;
		margin-top: 20px;
		height: 60px;
		// display: flex;
		// align-items: center;
		// justify-content: space-between;
		position: relative;
	}

	.icons {
		font-size: 32px;
		position: absolute;
		top: 50%;
		right: 20px;
		transform: translateY(-50%);
	}

	.selects h3 {
		font-size: 28px;
		height: 60px;
		line-height: 60px;
		margin: 0;
		color: #489fff;
		text-align: center;
		// color: ;
	}

	.autoFixed {
		padding: 30px;
		padding-bottom: 0;
		padding-top: 0;
		position: relative;

		.userBtn {
			position: absolute;
			right: 20px;
			top: 20px;
			width: 94px;
			height: 40px;
			text-align: center;
			line-height: 40px;

			background: none;
			border-radius: 5px;
			color: #4597ff;
		}

		.main {
			background: #ffffff;
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			border-radius: 5px;
			padding: 30px;
			box-sizing: border-box;
			position: relative;
			padding-top: 60px;
			padding-bottom: 0;

			// margin-bottom: 20px;
			.roomName {
				position: absolute;
				left: 20px;
				top: 20px;
				color: #64b0ff;
				font-weight: bold;
			}

			.hisotry-right {
				img {
					width: 150px;
					height: 130px;
				}
			}

			.history-item {
				margin-bottom: 20px;

				span {
					font-size: 28px;
					color: #333;
				}
			}
		}
	}

	.currentPre {
		display: flex;
		height: 80px;
		align-items: center;
		width: 80%;
		margin: 0 auto;
		border: 2px solid #7ab6f5;
		margin-top: 20px;
		border-radius: 40px;
		justify-content: center;
		background-color: #ffffff;
		margin-bottom: 20px;

		span {
			font-size: 32px;
			color: #7ab6f5;
			margin-right: 20px;
		}

		.fontss {
			font-size: 32px;
			color: #7ab6f5;
			margin-right: 20px;
		}

		i {
			font-size: 40px;
			color: #7ab6f5;
		}
	}

	.place {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.home {
		background: #f7f7f7;
		min-height: 100vh;
	}

	.demo {
		display: flex;
		align-items: center;
	}

	.demo span {
		font-size: 24px;
	}

	.disableds {
		background: #d0d0d0;
	}
	.modals{
		width: 80%;
		padding: 20px;
		span{
			font-size: 24px;
		}
		.van-popup--center{
			width: 80%!important;
			border-radius: 10;
		}
	}
	.history-item {
		margin-bottom: 20px;
	
		span {
			font-size: 28px;
			color: #333;
		}
	}
	.tts{
		.history-item{
			margin-bottom: 0;
		}
	}
</style>
